import { createSelector } from 'reselect';
const getmodal = (state) => state.ui.modal;
export const getModalIsVisible = createSelector([getmodal], (modal) => modal.isVisible);
export const getModalParams = createSelector([getmodal], (modal) => modal.modalParams);
export const getModalRequested = createSelector([getmodal], (modal) => modal.modalRequested);
export const getDialogProps = createSelector([getmodal], (modal) => modal.modalOptions.dialogProps);
export const getCloseModalButtonIsVisible = createSelector([getmodal], (modal) => modal.modalOptions.closeButtonIsVisible);
export const getModalTitle = createSelector([getmodal], (modal) => modal.modalOptions.modalTitle);
//# sourceMappingURL=modal.selector.js.map